import { useCallback } from 'react';
import { VISITOR_CSV_HEADERS } from '../constants';

interface UseDownloadVisitorsTemplateReturn {
  handleDownloadTemplate: () => void;
}

/**
 * Hook for downloading the CSV template for visitor list upload
 */
export const useDownloadVisitorsTemplate = (): UseDownloadVisitorsTemplateReturn => {
  const handleDownloadTemplate = useCallback(() => {
    const headers = VISITOR_CSV_HEADERS.join(',');

    const hiddenElement = document.createElement('a');
    hiddenElement.setAttribute('href', `data:text/csv;charset=utf-8,${encodeURIComponent(headers)}`);
    hiddenElement.setAttribute('target', '_blank');
    hiddenElement.setAttribute('download', 'visitors_template.csv');
    hiddenElement.click();
  }, []);

  return {
    handleDownloadTemplate,
  };
};
